import { setOwner } from '@ember/application';
import { task } from 'ember-concurrency';

export default class MessagingRoutesBaseHandler {
  options = {};

  constructor(owner, options) {
    setOwner(this, owner);
    this.options = options;
  }

  // Called when the user navigates to the route. Must be a concurrency task.
  onVisit = task({ drop: true }, async () => {});

  // Called when the user navigates away from the route. Must be a concurrency task.
  onLeave = task({ drop: true }, async () => {});

  get isVisiting() {
    return this.onVisit.isRunning;
  }

  get isLeaving() {
    return this.onLeave.isRunning;
  }
}
